//Información de las estaciones CIRES
var stations = [
  {
    latlng: [19.43131, -99.05888],
    clave: "AE02   ",
    nombre: "Esc. Prim. Gonz\u00E1lez Garz\u00F3n",
    direccion: " Aeropuerto, Zona Norte",
    amax: "  cm/s²",
    icon: "icostemp_act/plata.ico",
    foto: "sismos/AE02_.jpg",
    sismo: "sismos/AE02_.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.43634, -99.14576],
    clave: "AL01",
    nombre: "Alameda ",
    direccion: "Alameda Central",
    amax: " Amax: 2.64 cm/s²",
    icon: "icostemp_act/AL01_verde.ico",
    foto: "sismos/AL01_.jpg",
    sismo: "../acelerogramasjpg/AL0120210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.35862, -99.15422],
    clave: "AO24",
    nombre: "Alberca Ol\u00EDmpica",
    direccion: "R\u00EDo Churubusco y Divisi\u00F3n del Norte",
    amax: " Amax: 1.55 cm/s²",
    icon: "icostemp_act/AO24_azul.ico",
    foto: "sismos/AO24_.jpg",
    sismo: "../acelerogramasjpg/AO2420210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.38168, -99.10763],
    clave: "AP68   ",
    nombre: "Jard\u00EDn de Ni\u00F1os Juan B. de la Salle",
    direccion: "Apatlaco y San Lorenzo",
    amax: "  cm/s²",
    icon: "icostemp_act/plata.ico",
    foto: "sismos/AP68_.jpg",
    sismo: "sismos/AP68_.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.48114, -99.07595],
    clave: "AR14",
    nombre: "Esc. Prim. Jos\u00E9 Ordaz L\u00F3pez",
    direccion: "Puebla 2 y Providencia",
    amax: " Amax: 1.71 cm/s²",
    icon: "icostemp_act/AR14_azul.ico",
    foto: "sismos/AR14_.jpg",
    sismo: "../acelerogramasjpg/AR1420210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.39627, -99.08655],
    clave: "AU11",
    nombre: "Aut\u00F3dromo",
    direccion: "Aut\u00F3dromo Ricardo Rodr\u00EDguez",
    amax: " Amax: 1.48 cm/s²",
    icon: "icostemp_act/AU11_azul.ico",
    foto: "sismos/AU11_.jpg",
    sismo: "../acelerogramasjpg/AU1120210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.38407, -99.16864],
    clave: "AU46   ",
    nombre: "Esc. Sec. T\u00E9c. No. 14",
    direccion: "\u00C1ngel Urraza y Coyoac\u00E1n",
    amax: "  cm/s²",
    icon: "icostemp_act/plata.ico",
    foto: "sismos/AU46_.jpg",
    sismo: "sismos/AU46_.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.41071, -99.14541],
    clave: "BA49",
    nombre: "Buenos Aires",
    direccion: "Esc. Sec. No. 102",
    amax: " Amax: 2.50 cm/s²",
    icon: "icostemp_act/BA49_verde.ico",
    foto: "sismos/BA49_.jpg",
    sismo: "../acelerogramasjpg/BA4920210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.42562, -99.14793],
    clave: "BL45",
    nombre: "Balderas",
    direccion: "Esc. Prim. Centro Revoluci\u00F3n",
    amax: " Amax: 2.15 cm/s²",
    icon: "icostemp_act/BL45_verde.ico",
    foto: "sismos/BL45_.jpg",
    sismo: "../acelerogramasjpg/BL4520210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.46613, -99.1051],
    clave: "BO39",
    nombre: "Bondojito",
    direccion: "Esc. Prim. Miguel Lanz Duret",
    amax: " Amax: 2.17 cm/s²",
    icon: "icostemp_act/BO39_verde.ico",
    foto: "sismos/BO39_.jpg",
    sismo: "../acelerogramasjpg/BO3920210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.3728, -99.09843],
    clave: "C166   ",
    nombre: "CDAO, pozo a 12 mts.",
    direccion: "Central de Abastos",
    amax: "  cm/s²",
    icon: "icostemp_act/plata.ico",
    foto: "sismos/C166_.jpg",
    sismo: "sismos/C166_.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.3728, -99.0963],
    clave: "C266",
    nombre: "CDAO, pozo a 30 mts.",
    direccion: "Central de Abastos",
    amax: " Amax: 2.57 cm/s²",
    icon: "icostemp_act/C266_verde.ico",
    foto: "sismos/C266_.jpg",
    sismo: "../acelerogramasjpg/C26620210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.3736, -99.0973],
    clave: "C366",
    nombre: "CDAO, pozo a 60 mts.",
    direccion: "Central de Abastos",
    amax: " Amax: 1.71 cm/s²",
    icon: "icostemp_act/C366_azul.ico",
    foto: "sismos/C366_.jpg",
    sismo: "../acelerogramasjpg/C36620210320030631.jpg",
    nota: "Reubicada a 35 mts. de profundidad a partir del 19/04/2014",
    reg: "N",
  },
  {
    latlng: [19.3878, -99.15847],
    clave: "CA20   ",
    nombre: "Laboratorio, CIRES, A.C.",
    direccion: "Planta Baja",
    amax: "  cm/s²",
    icon: "icostemp_act/plata.ico",
    foto: "sismos/CA20_.jpg",
    sismo: "sismos/CA20_.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.42673, -99.11885],
    clave: "CA59",
    nombre: "Candelaria",
    direccion: "Deportivo Venustiano Carranza",
    amax: " Amax: 1.66 cm/s²",
    icon: "icostemp_act/CA59_azul.ico",
    foto: "sismos/CA59_.jpg",
    sismo: "../acelerogramasjpg/CA5920210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.3878, -99.15647],
    clave: "CB43   ",
    nombre: "Edificio A, CIRES",
    direccion: "Azotea",
    amax: "  cm/s²",
    icon: "icostemp_act/plata.ico",
    foto: "sismos/CB43_.jpg",
    sismo: "sismos/CB43_.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.387, -99.15747],
    clave: "CC55   ",
    nombre: "Edificio A, CIRES",
    direccion: "1er. Piso, Oficina GSTE",
    amax: "  cm/s²",
    icon: "icostemp_act/plata.ico",
    foto: "sismos/CC55_.jpg",
    sismo: "sismos/CC55_.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.3385, -99.08518],
    clave: "CE18",
    nombre: "Esc. Prim. Ram\u00F3n E. Villanueva",
    direccion: "Calle 3 y Carril",
    amax: " Amax: 0.79 cm/s²",
    icon: "icostemp_act/CE18_violeta.ico",
    foto: "sismos/CE18_.jpg",
    sismo: "../acelerogramasjpg/CE1820210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.46294, -99.06105],
    clave: "CE23",
    nombre: "CETIS",
    direccion: "CETIS No. 54",
    amax: " Amax: 1.02 cm/s²",
    foto: "sismos/CE23_.jpg",
    icon: "icostemp_act/CE23_azul.ico",
    sismo: "../acelerogramasjpg/CE2320210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.38465, -99.05397],
    clave: "CE32",
    nombre: "CETIS No. 57",
    direccion: "Av. Tepalcates y Verduzco",
    amax: " Amax: 1.38 cm/s²",
    icon: "icostemp_act/CE32_azul.ico",
    foto: "sismos/CE32_.jpg",
    sismo: "../acelerogramasjpg/CE3220210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.33063, -99.12576],
    clave: "CH84",
    nombre: "Esc. Prim. L. Portillo W.",
    direccion: "Culhuac\u00E1n",
    amax: " Amax: 2.30 cm/s²",
    icon: "icostemp_act/CH84_verde.ico",
    foto: "sismos/CH84_.jpg",
    sismo: "../acelerogramasjpg/CH8420210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.41946, -99.16579],
    clave: "CI05",
    nombre: "Cibeles",
    direccion: "Esc. Prim. Alberto Correa",
    amax: " Amax: 2.78 cm/s²",
    icon: "icostemp_act/CI05_verde.ico",
    foto: "sismos/CI05_.jpg",
    sismo: "../acelerogramasjpg/CI0520210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.41044, -99.15519],
    clave: "CJ03   ",
    nombre: "Centro Urbano Ju\u00E1rez",
    direccion: "Antonio M. Anza y Orizaba, Col. Roma",
    amax: "  cm/s²",
    icon: "icostemp_act/plata.ico",
    foto: "sismos/CJ03_.jpg",
    sismo: "sismos/CJ03_.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.41044, -99.15721],
    clave: "CJ04",
    nombre: "Multifamiliar Ju\u00E1rez II",
    direccion: "Antonio M. Anza y Orizaba, Col. Roma",
    amax: " Amax: 2.23 cm/s²",
    icon: "icostemp_act/CJ04_verde.ico",
    foto: "sismos/CJ04_.jpg",
    sismo: "../acelerogramasjpg/CJ0420210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.37326, -99.17038],
    clave: "CO47",
    nombre: "Coyoac\u00E1n",
    direccion: "Esc. Prim. Centro Escolar Alem\u00E1n",
    amax: " Amax: 1.29 cm/s²",
    icon: "icostemp_act/CO47_azul.ico",
    foto: "sismos/CO47_.jpg",
    sismo: "../acelerogramasjpg/CO4720210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.42064, -99.15881],
    clave: "CO56",
    nombre: "Esc. Sec. T\u00E9c. No. 18",
    direccion: "C\u00F3rdoba No. 68, Col. Roma",
    amax: " Amax: 2.95 cm/s²",
    icon: "icostemp_act/CO56_verde.ico",
    foto: "sismos/CO56_.jpg",
    sismo: "../acelerogramasjpg/CO5620210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.43929, -99.08419],
    clave: "CP28",
    nombre: "Cerro del Pe\u00F1\u00F3n",
    direccion: "Pe\u00F1\u00F3n de los Ba\u00F1os",
    amax: " Amax: 2.01 cm/s²",
    icon: "icostemp_act/CP28_verde.ico",
    foto: "sismos/CP28_.jpg",
    sismo: "../acelerogramasjpg/CP2820210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.3728, -99.0983],
    clave: "CS66   ",
    nombre: "CDAO",
    direccion: "Central de Abastos",
    amax: "  cm/s²",
    icon: "icostemp_act/plata.ico",
    foto: "sismos/CS66_.jpg",
    sismo: "sismos/CS66_.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.36621, -99.22635],
    clave: "CS78",
    nombre: "Esc. Sec. T\u00E9c. No. 43",
    direccion: "Colinas del Sur",
    amax: " Amax: 1.49 cm/s²",
    icon: "icostemp_act/CS78_azul.ico",
    foto: "sismos/CS78_.jpg",
    sismo: "../acelerogramasjpg/CS7820210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.48838, -99.11403],
    clave: "CT64",
    nombre: "Cerro del Tepeyac",
    direccion: "M. Salas y Cantera",
    amax: " Amax: 0.34 cm/s²",
    icon: "icostemp_act/CT64_violeta.ico",
    foto: "sismos/CT64_.jpg",
    sismo: "../acelerogramasjpg/CT6420210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.29444, -99.10391],
    clave: "CU80   ",
    nombre: "Esc. Prim. R. L\u00F3pez Velarde",
    direccion: "Perif\u00E9rico Sur, Cuemanco",
    amax: "  cm/s²",
    icon: "icostemp_act/plata.ico",
    foto: "sismos/CU80_.jpg",
    sismo: "sismos/CU80_.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.3428, -99.2032],
    clave: "D170   ",
    nombre: "IMP - SEP pozo 10 mts.",
    direccion: "Antiguo Camino a Acapulco",
    amax: "  cm/s²",
    icon: "icostemp_act/plata.ico",
    foto: "sismos/D170_.jpg",
    sismo: "sismos/D170_.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.3428, -99.2012],
    clave: "D270   ",
    nombre: "IMP - SEP pozo 40 mts.",
    direccion: "Antiguo Camino a Acapulco",
    amax: "  cm/s²",
    icon: "icostemp_act/plata.ico",
    foto: "sismos/D270_.jpg",
    sismo: "sismos/D270_.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.43328, -99.09725],
    clave: "DM12",
    nombre: "Deportivo Moctezuma",
    direccion: "Oriente 168 y Norte 25",
    amax: " Amax: 2.12 cm/s²",
    icon: "icostemp_act/DM12_verde.ico",
    foto: "sismos/DM12_.jpg",
    sismo: "../acelerogramasjpg/DM1220210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.50167, -99.18273],
    clave: "DR16",
    nombre: "Deportivo Reynosa, Azcapotzalco",
    direccion: "Eje 5 Norte y San Pablo",
    amax: " Amax: 2.06 cm/s²",
    icon: "icostemp_act/DR16_verde.ico",
    foto: "sismos/DR16_.jpg",
    sismo: "../acelerogramasjpg/DR1620210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.33293, -99.14397],
    clave: "DX37",
    nombre: "Xotepingo",
    direccion: "D. G. C. O. H.",
    amax: " Amax: 1.36 cm/s²",
    icon: "icostemp_act/DX37_azul.ico",
    foto: "sismos/DX37_.jpg",
    sismo: "../acelerogramasjpg/DX3720210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.38897, -99.17778],
    clave: "EO30",
    nombre: "Parque Esparza Oteo",
    direccion: "Pensylvania y Georgia",
    amax: " Amax: 1.50 cm/s²",
    icon: "icostemp_act/EO30_azul.ico",
    foto: "sismos/EO30_.jpg",
    sismo: "../acelerogramasjpg/EO3020210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.40243, -99.17788],
    clave: "ES57",
    nombre: "Escand\u00F3n",
    direccion: "Esc. Prim. Miguel F. Mart\u00EDnez",
    amax: " Amax: 1.49 cm/s²",
    icon: "icostemp_act/ES57_azul.ico",
    foto: "sismos/ES57_.jpg",
    sismo: "../acelerogramasjpg/ES5720210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.4249, -99.1594],
    clave: "EX08",
    nombre: "Esc. Sec. No. 3, azotea 1",
    direccion: "Av. Chapultepec y Niza",
    amax: " Amax: 4.01 cm/s²",
    icon: "icostemp_act/EX08_verde.ico",
    foto: "sismos/EX08_.jpg",
    sismo: "../acelerogramasjpg/EX0820210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.4249, -99.1574],
    clave: "EX09",
    nombre: "Esc. Sec. No. 3, Biblioteca",
    direccion: "Av. Chapultepec y Niza",
    amax: " Amax: 1.91 cm/s²",
    icon: "icostemp_act/EX09_azul.ico",
    foto: "sismos/EX09_.jpg",
    sismo: "../acelerogramasjpg/EX0920210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.4241, -99.1584],
    clave: "EX12",
    nombre: "Esc. Sec. No. 3, P. B. Centro-Edificio 1",
    direccion: "Av. Chapultepec y Niza",
    amax: " Amax: 2.66 cm/s²",
    icon: "icostemp_act/EX12_verde.ico",
    foto: "sismos/EX12_.jpg",
    sismo: "../acelerogramasjpg/EX1220210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.30041, -99.21015],
    clave: "FJ74",
    nombre: "Fundaci\u00F3n Javier Barros Sierra",
    direccion: "Carretera al Ajusco, No. 203",
    amax: " Amax: 1.69 cm/s²",
    icon: "icostemp_act/FJ74_azul.ico",
    foto: "sismos/FJ74_.jpg",
    sismo: "../acelerogramasjpg/FJ7420210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.43934, -99.14089],
    clave: "GA62   ",
    nombre: "Esc. Sec. T\u00E9c. No. 2",
    direccion: "Eje Central No. 10. Centro",
    amax: "  cm/s²",
    icon: "icostemp_act/plata.ico",
    foto: "sismos/GA62_.jpg",
    sismo: "sismos/GA62_.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.3167, -99.10624],
    clave: "GC38",
    nombre: "Jard\u00EDn de Ni\u00F1os Luz G. Campillo",
    direccion: "Juana Medina y Guarder\u00EDa",
    amax: " Amax: 2.11 cm/s²",
    icon: "icostemp_act/GC38_verde.ico",
    foto: "sismos/GC38_.jpg",
    sismo: "../acelerogramasjpg/GC3820210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.47552, -99.18016],
    clave: "GR27",
    nombre: "Granjas",
    direccion: "Esc. Sec. No. 55",
    amax: " Amax: 2.23 cm/s²",
    icon: "icostemp_act/GR27_verde.ico",
    foto: "sismos/GR27_.jpg",
    sismo: "../acelerogramasjpg/GR2720210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.4183, -99.0786],
    clave: "HA41   ",
    nombre: "Hangares",
    direccion: "Hangar Cometa",
    amax: "  cm/s²",
    icon: "icostemp_act/plata.ico",
    foto: "sismos/HA41_.jpg",
    sismo: "sismos/HA41_.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.42553, -99.13047],
    clave: "HJ72",
    nombre: "Hospital Ju\u00E1rez",
    direccion: "Jes\u00FAs Mar\u00EDa, Centro",
    amax: " Amax: 2.40 cm/s²",
    icon: "icostemp_act/HJ72_verde.ico",
    foto: "sismos/HJ72_.jpg",
    sismo: "../acelerogramasjpg/HJ7220210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.3459, -99.13009],
    clave: "IB22",
    nombre: "Esc. Sec. T\u00E9c. No. 95",
    direccion: "Cerro Crest\u00F3n y Cerro Mezontepec",
    amax: " Amax: 2.19 cm/s²",
    icon: "icostemp_act/IB22_verde.ico",
    foto: "sismos/IB22_.jpg",
    sismo: "../acelerogramasjpg/IB2220210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.34339, -99.204],
    clave: "IM40   ",
    nombre: "Inst. M\u00E9dico Pedag\u00F3gico",
    direccion: "Antiguo Camino a Acapulco",
    amax: "  cm/s²",
    icon: "icostemp_act/plata.ico",
    foto: "sismos/IM40_.jpg",
    sismo: "sismos/IM40_.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.40635, -99.1257],
    clave: "JA43",
    nombre: "Jamaica",
    direccion: "Centro Cultural Jos\u00E9 Ma. Pino Zu\u00E1rez",
    amax: " Amax: 2.06 cm/s²",
    icon: "icostemp_act/JA43_verde.ico",
    foto: "sismos/JA43_.jpg",
    sismo: "../acelerogramasjpg/JA4320210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.31372, -99.12746],
    clave: "JC54",
    nombre: "Parque Jardines de Coyoac\u00E1n",
    direccion: "Dalias e Iris",
    amax: " Amax: 2.54 cm/s²",
    icon: "icostemp_act/JC54_verde.ico",
    foto: "sismos/JC54_.jpg",
    sismo: "../acelerogramasjpg/JC5420210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.30733, -98.96341],
    clave: "LI33",
    nombre: "LICONSA",
    direccion: "Planta LICONSA Tl\u00E1huac",
    amax: " Amax: 2.05 cm/s²",
    icon: "icostemp_act/LI33_verde.ico",
    foto: "sismos/LI33_.jpg",
    sismo: "../acelerogramasjpg/LI3320210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.42703, -99.15739],
    clave: "LI58",
    nombre: "Esc. Sec. Dna. No. 23",
    direccion: "Liverpool No. 40, Col. Ju\u00E1rez",
    amax: " Amax: 2.89 cm/s²",
    icon: "icostemp_act/LI58_verde.ico",
    foto: "sismos/LI58_.jpg",
    sismo: "../acelerogramasjpg/LI5820210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.49367, -99.12781],
    clave: "LV17",
    nombre: "Lindavista",
    direccion: "Parque Deportivo Av. Lindavista",
    amax: " Amax: 1.98 cm/s²",
    icon: "icostemp_act/LV17_azul.ico",
    foto: "sismos/LV17_.jpg",
    sismo: "../acelerogramasjpg/LV1720210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.43913, -99.18213],
    clave: "ME52   ",
    nombre: "Esc. Sec. T\u00E9c. Rafael Dond\u00E9 ",
    direccion: "Mariano Escobedo y Lago Alberto",
    amax: "  cm/s²",
    icon: "icostemp_act/plata.ico",
    foto: "sismos/ME52_.jpg",
    sismo: "sismos/ME52_.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.28396, -99.12536],
    clave: "MI15",
    nombre: "Miramontes",
    direccion: "Glorieta Miramontes",
    amax: " Amax: 2.83 cm/s²",
    icon: "icostemp_act/MI15_verde.ico",
    foto: "sismos/MI15_.jpg",
    sismo: "../acelerogramasjpg/MI1520210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.42611, -99.19051],
    clave: "MT50   ",
    nombre: "Mariscal Tito",
    direccion: "Reforma y Gandhi",
    amax: "  cm/s²",
    icon: "icostemp_act/plata.ico",
    foto: "sismos/MT50_.jpg",
    sismo: "sismos/MT50_.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.3459, -99.0486],
    clave: "MY19",
    nombre: "Meyehualco",
    direccion: "Deportivo Santa Cruz Meyehualco",
    amax: " Amax: 1.66 cm/s²",
    icon: "icostemp_act/MY19_azul.ico",
    foto: "sismos/MY19_.jpg",
    sismo: "../acelerogramasjpg/MY1920210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.39336, -99.00162],
    clave: "NZ20",
    nombre: "Nezahualc\u00F3yotl",
    direccion: "Deportivo Neza - IMSS",
    amax: " Amax: 1.85 cm/s²",
    icon: "icostemp_act/NZ20_azul.ico",
    foto: "sismos/NZ20_.jpg",
    sismo: "../acelerogramasjpg/NZ2020210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.4178, -99.02533],
    clave: "NZ31   ",
    nombre: "Nezahualc\u00F3yotl",
    direccion: "Esc. Normal ENEM No. 52",
    amax: "  cm/s²",
    icon: "icostemp_act/plata.ico",
    foto: "sismos/NZ31_.jpg",
    sismo: "sismos/NZ31_.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.20093, -99.04927],
    clave: "PA34",
    nombre: "Esc. Prim. \u00C1lvaro Obreg\u00F3n",
    direccion: "San Pedro Actopan",
    amax: " Amax: 0.99 cm/s²",
    icon: "icostemp_act/PA34_violeta.ico",
    foto: "sismos/PA34_.jpg",
    sismo: "../acelerogramasjpg/PA3420210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.40622, -99.10011],
    clave: "PD42",
    nombre: "Palacio de los Deportes",
    direccion: "R\u00EDo Churubusco y A\u00F1il",
    amax: " Amax: 1.78 cm/s²",
    icon: "icostemp_act/PD42_azul.ico",
    foto: "sismos/PD42_.jpg",
    sismo: "../acelerogramasjpg/PD4220210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.39026, -99.13238],
    clave: "PE10",
    nombre: "Esc. Prim. Plutarco El\u00EDas Calles",
    direccion: "P. El\u00EDas Calles y Santiago",
    amax: " Amax: 2.25 cm/s²",
    icon: "icostemp_act/PE10_verde.ico",
    foto: "sismos/PE10_.jpg",
    sismo: "../acelerogramasjpg/PE1020210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.44771, -99.10069],
    clave: "RI76",
    nombre: "Rep\u00FAblica de Italia",
    direccion: "Bolivares y Carlos Marx",
    amax: " Amax: 1.18 cm/s²",
    icon: "icostemp_act/RI76_azul.ico",
    foto: "sismos/RI76_.jpg",
    sismo: "../acelerogramasjpg/RI7620210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.43573, -99.12889],
    clave: "RM48   ",
    nombre: "Esc. Prim. Rodolfo Men\u00E9ndez",
    direccion: "Loreto y San Ildefonso",
    amax: "  cm/s²",
    icon: "icostemp_act/plata.ico",
    foto: "sismos/RM48_.jpg",
    sismo: "sismos/RM48_.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.393, -99.149],
    clave: "S160",
    nombre: "SCT-CENDI-SEDESOL, pozo a 7 mts.",
    direccion: "Xola y Universidad",
    amax: " Amax: 3.29 cm/s²",
    icon: "icostemp_act/S160_verde.ico",
    foto: "sismos/S160_.jpg",
    sismo: "../acelerogramasjpg/S16020210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.393, -99.14687],
    clave: "S260   ",
    nombre: "SCT-CENDI-SEDESOL, pozo a 25 mts.",
    direccion: "Xola y Universidad",
    amax: "  cm/s²",
    icon: "icostemp_act/plata.ico",
    foto: "sismos/S260_.jpg",
    sismo: "sismos/S260_.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.3938, -99.148],
    clave: "S360   ",
    nombre: "SCT-CENDI-SEDESOL, pozo a 40 mts.",
    direccion: "Xola y Universidad",
    amax: "  cm/s²",
    icon: "icostemp_act/plata.ico",
    foto: "sismos/S360_.jpg",
    sismo: "sismos/S360_.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.37626, -99.14824],
    clave: "SI53",
    nombre: "San Sim\u00F3n",
    direccion: "Esc. Prim. Pedro Ascencio",
    amax: " Amax: 1.79 cm/s²",
    icon: "icostemp_act/SI53_azul.ico",
    foto: "sismos/SI53_.jpg",
    sismo: "../acelerogramasjpg/SI5320210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.36621, -99.119],
    clave: "SP51",
    nombre: "Sector popular",
    direccion: "Esc. Prim. Alberto Mazferrer",
    amax: " Amax: 2.30 cm/s²",
    icon: "icostemp_act/SP51_verde.ico",
    foto: "sismos/SP51_.jpg",
    sismo: "../acelerogramasjpg/SP5120210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.393, -99.147],
    clave: "SS60   ",
    nombre: "SCT-CENDI-SEDESOL",
    direccion: "Xola y Universidad",
    amax: "  cm/s²",
    icon: "icostemp_act/plata.ico",
    foto: "sismos/SS60_.jpg",
    sismo: "sismos/SS60_.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.4269, -99.2217],
    clave: "TE07   ",
    nombre: "Tecamachalco",
    direccion: "Laboratorios SARH",
    amax: "  cm/s²",
    icon: "icostemp_act/plata.ico",
    foto: "sismos/TE07_.jpg",
    sismo: "sismos/TE07_.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.27938, -99.00068],
    clave: "TH35",
    nombre: "Tl\u00E1huac",
    direccion: "Esc. Prim. Antonio Caso",
    amax: " Amax: 2.63 cm/s²",
    icon: "icostemp_act/TH35_verde.ico",
    foto: "sismos/TH35_.jpg",
    sismo: "../acelerogramasjpg/TH3520210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.45081, -99.13386],
    clave: "TL08",
    nombre: "Deportivo Antonio Caso T-II",
    direccion: "Nonoalco - Tlatelolco",
    amax: " Amax: 1.80 cm/s²",
    icon: "icostemp_act/TL08_azul.ico",
    foto: "sismos/TL08_.jpg",
    sismo: "../acelerogramasjpg/TL0820210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.45376, -99.14281],
    clave: "TL55",
    nombre: "Tlatelolco",
    direccion: "Deportivo 5 de Mayo",
    amax: " Amax: 1.81 cm/s²",
    icon: "icostemp_act/TL55_azul.ico",
    foto: "sismos/TL55_.jpg",
    sismo: "../acelerogramasjpg/TL5520210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.29311, -99.17188],
    clave: "TP13   ",
    nombre: "Tlalpan",
    direccion: "Esc. Prim. 1ro. de Mayo",
    amax: "  cm/s²",
    icon: "icostemp_act/plata.ico",
    foto: "sismos/TP13_.jpg",
    sismo: "sismos/TP13_.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.43433, -99.1659],
    clave: "UC44",
    nombre: "Unidad Colonia IMSS",
    direccion: "Villalongin No. 117",
    amax: " Amax: 3.82 cm/s²",
    icon: "icostemp_act/UC44_verde.ico",
    foto: "sismos/UC44_.jpg",
    sismo: "../acelerogramasjpg/UC4420210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.37245, -99.26357],
    clave: "UI21   ",
    nombre: "U. Iberoamericana",
    direccion: "Universidad Iberoamericana",
    amax: "  cm/s²",
    icon: "icostemp_act/plata.ico",
    foto: "sismos/UI21_.jpg",
    sismo: "sismos/UI21_.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.45475, -99.12272],
    clave: "VG09",
    nombre: "Valle G\u00F3mez",
    direccion: "Esc. Sec. No. 104",
    amax: " Amax: 2.81 cm/s²",
    icon: "icostemp_act/VG09_verde.ico",
    foto: "sismos/VG09_.jpg",
    sismo: "../acelerogramasjpg/VG0920210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.38153, -99.12531],
    clave: "VM29",
    nombre: "Villa del Mar",
    direccion: "Jard\u00EDn de Ni\u00F1os Valent\u00EDn Z. Orozco",
    amax: " Amax: 2.80 cm/s²",
    icon: "icostemp_act/VM29_verde.ico",
    foto: "sismos/VM29_.jpg",
    sismo: "../acelerogramasjpg/VM2920210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.27154, -99.10269],
    clave: "XO36",
    nombre: "Jard\u00EDn de Ni\u00F1os Xochimilco",
    direccion: "Club Espa\u00F1a y Chicoco",
    amax: " Amax: 2.23 cm/s²",
    icon: "icostemp_act/XO36_verde.ico",
    foto: "sismos/XO36_.jpg",
    sismo: "../acelerogramasjpg/XO3620210320030631.jpg",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.3841, -99.0599],
    clave: "CCHO",
    nombre: "Colegio de Ciencias y Humanidades, plantel Oriente",
    direccion: "Red S\u00EDsmica de Bachillerato",
    amax: "",
    icon: "",
    foto: "",
    sismo: "",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.4823, -99.1405],
    clave: "CCHV",
    nombre: "Colegio de Ciencias y Humanidades, plantel Vallejo",
    direccion: "Red S\u00EDsmica de Bachillerato",
    amax: "",
    icon: "",
    foto: "",
    sismo: "",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.2712, -99.1215],
    clave: "ENP1",
    nombre: "Escuela Nacional Preparatoria, número 1",
    direccion: "Red S\u00EDsmica de Bachillerato",
    amax: "",
    icon: "",
    foto: "",
    sismo: "",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.385, -99.0991],
    clave: "ENP2",
    nombre: "Escuela Nacional Preparatoria, número 2",
    direccion: "Red S\u00EDsmica de Bachillerato",
    amax: "",
    icon: "",
    foto: "",
    sismo: "",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.4827, -99.0935],
    clave: "ENP3",
    nombre: "Escuela Nacional Preparatoria, número 3",
    direccion: "Red S\u00EDsmica de Bachillerato",
    amax: "",
    icon: "",
    foto: "",
    sismo: "",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.4044, -99.1962],
    clave: "ENP4",
    nombre: "Escuela Nacional Preparatoria, número 4",
    direccion: "Red S\u00EDsmica de Bachillerato",
    amax: "",
    icon: "",
    foto: "",
    sismo: "",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.3074, -99.1348],
    clave: "ENP5",
    nombre: "Escuela Nacional Preparatoria, número 5",
    direccion: "Red S\u00EDsmica de Bachillerato",
    amax: "",
    icon: "",
    foto: "",
    sismo: "",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.353, -99.156],
    clave: "ENP6",
    nombre: "Escuela Nacional Preparatoria, número 6",
    direccion: "Red S\u00EDsmica de Bachillerato",
    amax: "",
    icon: "",
    foto: "",
    sismo: "",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.385, -99.1257],
    clave: "ENP7",
    nombre: "Escuela Nacional Preparatoria, número 7",
    direccion: "Red S\u00EDsmica de Bachillerato",
    amax: "",
    icon: "",
    foto: "",
    sismo: "",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.3673, -99.1933],
    clave: "ENP8",
    nombre: "Escuela Nacional Preparatoria, número 8",
    direccion: "Red S\u00EDsmica de Bachillerato",
    amax: "",
    icon: "",
    foto: "",
    sismo: "",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.4841, -99.1294],
    clave: "ENP9",
    nombre: "Escuela Nacional Preparatoria, número 9",
    direccion: "Red S\u00EDsmica de Bachillerato",
    amax: "",
    icon: "",
    foto: "",
    sismo: "",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.3905, -99.1676],
    clave: "DENP",
    nombre: "DENP",
    direccion: "Red S\u00EDsmica de Bachillerato",
    amax: "",
    icon: "",
    foto: "",
    sismo: "",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.2888, -99.1337],
    clave: "CMAD",
    nombre: "CMAD",
    direccion: "Red S\u00EDsmica de Bachillerato",
    amax: "",
    icon: "",
    foto: "",
    sismo: "",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.3272, -99.1768],
    clave: "SSNCU",
    nombre: "SSNCU",
    direccion: "Red S\u00EDsmica de Bachillerato",
    amax: "",
    icon: "",
    foto: "",
    sismo: "",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.329, -99.178],
    clave: "PZCU",
    nombre: "PZCU",
    direccion: "Red S\u00EDsmica de Bachillerato",
    amax: "",
    icon: "",
    foto: "",
    sismo: "",
    nota: " ",
    reg: "N",
  },
  {
    latlng: [19.3206, -99.2553],
    clave: "MAVM",
    nombre: "MAVM",
    direccion: "Red del Servicio Sismológico Nacional",
    amax: "",
    icon: "",
    foto: "",
    sismo: "",
    nota: " ",
    reg: "N",
  },
];

export default stations;
